/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_Price_Col_ErpInputs */

const vi_online_price_col_erp = /** @type {(inputs: Online_Price_Col_ErpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá ERP + VAT`)
};

/**

* @param {Online_Price_Col_ErpInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_col_erp = /** @type {((inputs?: Online_Price_Col_ErpInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Col_ErpInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_col_erp(inputs)
});